import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropletOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2C12 2 5 10 5 15a7 7 0 0 0 14 0c0-5-7-13-7-13z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgDropletOutlined;
